import React from 'react';
import { BrandFormModalView } from './BrandFormModalView';
import {
    useBrandForm,
    type BrandFormInitialValues,
    type BrandFormSubmit,
} from './useBrandForm';

type BrandFormModalProps = {
    error: string | null;
    initialValues: BrandFormInitialValues | null;
    isOpen: boolean;
    isSubmitting: boolean;
    mode: 'create' | 'edit';
    onClose: () => void;
    onSubmit: (input: BrandFormSubmit) => void;
};

/**
 * Container for the Add / Edit Brand modal: instantiates the form-state hook
 * and hands its output (plus the modal-chrome props) to the render-only View.
 */
export const BrandFormModal: React.FC<BrandFormModalProps> = ({
    error,
    initialValues,
    isOpen,
    isSubmitting,
    mode,
    onClose,
    onSubmit,
}) => {
    const form = useBrandForm({
        initialValues: initialValues ?? undefined,
        isOpen,
        onSubmit,
    });

    return (
        <BrandFormModalView
            error={error}
            form={form}
            isOpen={isOpen}
            isSubmitting={isSubmitting}
            mode={mode}
            onClose={onClose}
        />
    );
};
